export enum ContentTypeEnum {
  TECHNICAL_INFORMATIVES = 'informativos-tecnicos',
  SUPPORT_MATERIALS = 'materiais-de-apoio',
  VIDEOS_AND_EVENTS = 'videos-e-eventos'
}
